import http from '../../../../api/http'

// 온라인 특별채용관 리스트
function ojfGnbList(paramObj) {
    return http.post('/mypage/ojf/onlineJobFair/retrieveAllOjfPaging', {
        searchOjfStateGb: paramObj.searchOjfStateGb, // "01,02,03,04"
        searchJoinStateGb: paramObj.searchJoinStateGb, // "01,02,03,04,11,21"
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 30
        userId: paramObj.userId, // 0
        corpId: paramObj.corpId, // 0
    })
}

// 온라인 특별채용관 상세 상단 정보 => 로그인 X
function ojfGnbDetailByOjfId(id) {
    return http.get(`/mypage/ojf/onlineJobFair/retrieveOjfByOjfId?ojfId=${id}`);
}
// 비공개 온라인 특별채용관 상세 상단 정보 => 로그인 X
function ojfGnbDetailByOjfUuid(ojfUuid) {
    return http.get(`/mypage/ojf/onlineJobFair/retrieveOjfByOjfUuid?ojfUuid=${ojfUuid}`);
}

// 온라인 특별채용관 상세 상단 정보 => 구직자 로그인
function ojfGnbDetailByOjfIdAndUserID(id) {
    return http.get(`mypage/ojf/onlineJobFair/retrieveOjfByOjfIdAndUserId?ojfId=${id}`);
}
// 비공개 온라인 특별채용관 상세 상단 정보 => 구직자 로그인
function ojfGnbDetailByOjfUuidAndUserID(ojfUuid) {
    return http.get(`mypage/ojf/onlineJobFair/retrieveOjfByOjfUuidAndUserId?ojfUuid=${ojfUuid}`);
}

// 온라인 특별채용관 상세 상단 정보 => 기업 로그인
function ojfGnbDetailByOjfIdAndCorpId(id) {
    return http.get(`mypage/ojf/onlineJobFair/retrieveOjfByOjfIdAndCorpId?ojfId=${id}`);
}
// 비공개 온라인 특별채용관 상세 상단 정보 => 기업 로그인
function ojfGnbDetailByOjfUuidAndCorpId(ojfUuid) {
    return http.get(`mypage/ojf/onlineJobFair/retrieveOjfByOjfUuidAndCorpId?ojfUuid=${ojfUuid}`);
}

// 참가기업 리스트
function ojfGnbRecruitmentHallList(paramObj) {
    return http.post('/mypage/ojf/recruitmentHall/retrieveAllRecruitmentHallPaging', {
        ojfId: paramObj.ojfId, // 0
        searchCorpName: paramObj.searchCorpName, // string
        joinStateGb: paramObj.joinStateGb, // 11
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 12
        userId: paramObj.userId, // 0
    })
}

// 기업정보 보기의 채용공고 리스트
function ojfGnbCorpInfoJobNoticeList(paramObj) {
    return http.post('/mypage/ojf/jobNotice/retrieveAllJobNoticeByCorpId', {
        ojfId: paramObj.ojfId, // 0
        corpId: paramObj.corpId, // 0
        resumeId: paramObj.resumeId, // 0
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 10
        userId: paramObj.userId, // 0
        requestUserId: paramObj.requestUserId, // 0
    })
}

// 채용공고 리스트
function ojfGnbJobNoticeList(paramObj) {
    return http.post('/mypage/ojf/jobNotice/retrieveAllJobNoticePaging', {
        ojfId: paramObj.ojfId, // 0
        searchCorpName: paramObj.searchCorpName, // string
        joinStateGb: paramObj.joinStateGb, // 11
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 12
        userId: paramObj.userId, // 0
    })
}

// 인재정보 리스트
function ojfGnbResumeList(paramObj) {
    return http.post('/mypage/ojf/ojfResume/retrieveAllOjfResumePaging', {
        ojfId: paramObj.ojfId, // 0
        joinStateGb: paramObj.joinStateGb, // 11
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 12
        userId: paramObj.userId, // 0
        searchMonths: paramObj.searchMonths, // 1
        searchResidences: paramObj.searchResidences, // string
        searchInterests: paramObj.searchInterests, // 설계,장비,소재,제조공정,패키지,테스트,SW,기타
        searchSchoolGbs: paramObj.searchSchoolGbs, // 01,02,03,04,05
        searchEduTenureGbs: paramObj.searchEduTenureGbs, // 01,02,03,04,05,06
        searchMajorGbs: paramObj.searchMajorGbs, // 00,01,10,09,08,02,03,34,33,30,32,07,04,05,06,11,31,50,60,61,62,63,64,71,72,73,74,75,80,81,82,83,90
    })
}

// 인재정보 리스트 - 구직자 암호화
function ojfGnbResumeList2(paramObj) {
    return http.post('/mypage/ojf/ojfResume/retrieveAllOjfResumePaging2', {
        ojfId: paramObj.ojfId, // 0
        joinStateGb: paramObj.joinStateGb, // 11
        pageNumber: paramObj.pageNumber, // 0
        size: paramObj.size, // 12
        userId: paramObj.userId, // 0
        searchMonths: paramObj.searchMonths, // 1
        searchResidences: paramObj.searchResidences, // string
        searchInterests: paramObj.searchInterests, // 설계,장비,소재,제조공정,패키지,테스트,SW,기타
        searchSchoolGbs: paramObj.searchSchoolGbs, // 01,02,03,04,05
        searchEduTenureGbs: paramObj.searchEduTenureGbs, // 01,02,03,04,05,06
        searchMajorGbs: paramObj.searchMajorGbs, // 00,01,10,09,08,02,03,34,33,30,32,07,04,05,06,11,31,50,60,61,62,63,64,71,72,73,74,75,80,81,82,83,90
    })
}

// 인재정보 엑셀 다운로드
function ojfGnbResumeExcel(ojfId) {
    return http.post('/mypage/ojf/ojfResume/retrieveAllOjfResumeExcel', {
        ojfId, // 0
        joinStateGb: 11, // 11
    }, {
        responseType: 'blob',
    })
}

export default {
    ojfGnbList, // 온라인 특별채용관 리스트
    ojfGnbDetailByOjfId, // 온라인 특별채용관 상세 상단 정보 => 로그인 X
    ojfGnbDetailByOjfUuid, // 비공개 온라인 특별채용관 상세 상단 정보 => 로그인 X
    ojfGnbDetailByOjfIdAndUserID, // 온라인 특별채용관 상세 상단 정보 => 구직자 로그인
    ojfGnbDetailByOjfUuidAndUserID, // 비공개 온라인 특별채용관 상세 상단 정보 => 구직자 로그인
    ojfGnbDetailByOjfIdAndCorpId, // 온라인 특별채용관 상세 상단 정보 => 기업 로그인
    ojfGnbDetailByOjfUuidAndCorpId, // 비공개 온라인 특별채용관 상세 상단 정보 => 기업 로그인
    ojfGnbRecruitmentHallList, // 참가기업 리스트
    ojfGnbCorpInfoJobNoticeList, // 기업정보 보기의 채용공고 리스트
    ojfGnbJobNoticeList, // 채용공고 리스트
    ojfGnbResumeList, // 인재정보 리스트
    ojfGnbResumeList2, // 인재정보 리스트 - 구직자 암호화
    ojfGnbResumeExcel, //
};